import { JSX } from "react";
import ReactJson from "@microlink/react-json-view";

interface AccuracyEvidenceTabProps {
  src: object;
  collapsed: number | boolean;
  expanding: boolean;
}

export default function AccuracyEvidenceTab(evidence: AccuracyEvidenceTabProps): JSX.Element {
  return (
    evidence.src !== null
    ? <ReactJson
        src={evidence.src}
        name={false}
        collapsed={evidence.collapsed}
        enableClipboard={false}
        displayDataTypes={false}
        displayObjectSize={false}
      />
    : !evidence.expanding
      ? <p>No corroborating data found for this provider</p>
      : <p></p>
  );
}
